<mat-dialog-content
  ><app-travel-requests [requestToEdit]="data" (action)="actionClick($event)"></app-travel-requests>
</mat-dialog-content>
